export const replaceText = (text, players) => {
    const regex = /[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/ig
    let m

    while ((m = regex.exec(text)) !== null) {
        if (m.index === regex.lastIndex) regex.lastIndex++      
        m.forEach(match => text = text.replace("#"+match, players.find(player => player.id === match).name))
    }

    return text
}
